module.exports = __webpack_public_path__ + "img/serve2.69af857e.png";